import i18n from '@/i18n';

function def_linguagem(show = false, idioma = 'pt-BR') {
  return {
    show_language: show,
    certificate_title: i18n.t('modulos.stimulsoft.certificate_title', idioma),
    requestor_data: i18n.t('modulos.stimulsoft.requestor_data', idioma),
    contractor: i18n.t('modulos.stimulsoft.contractor', idioma),
    requester: i18n.t('modulos.stimulsoft.requester', idioma),
    order_service: i18n.t('modulos.stimulsoft.order_service', idioma),
    calibration_date: i18n.t('modulos.stimulsoft.calibration_date', idioma),
    receipt_date: i18n.t('modulos.stimulsoft.receipt_date', idioma),
    emission_date: i18n.t('modulos.stimulsoft.emission_date', idioma),
    equipment_data: i18n.t('modulos.stimulsoft.equipment_data', idioma),
    name: i18n.t('modulos.stimulsoft.name', idioma),
    manufacturer: i18n.t('modulos.stimulsoft.manufacturer', idioma),
    model: i18n.t('modulos.stimulsoft.model', idioma),
    serial_number: i18n.t('modulos.stimulsoft.serial_number', idioma),
    code: i18n.t('modulos.stimulsoft.code', idioma),
    type_indication: i18n.t('modulos.stimulsoft.type_indication', idioma),
    software: i18n.t('modulos.stimulsoft.software', idioma),
    procedure: i18n.t('modulos.stimulsoft.procedure', idioma),
    results_table: i18n.t('modulos.stimulsoft.results_table', idioma),
    unit: i18n.t('modulos.stimulsoft.unit', idioma),
    indication_equipment: i18n.t(
      'modulos.stimulsoft.indication_equipment',
      idioma
    ),
    reference_value: i18n.t('modulos.stimulsoft.reference_value', idioma),
    measurement_error: i18n.t('modulos.stimulsoft.measurement_error', idioma),
    hysteresis: i18n.t('modulos.stimulsoft.hysteresis', idioma),
    uncertainty_measurement: i18n.t(
      'modulos.stimulsoft.uncertainty_measurement',
      idioma
    ),
    bias_chart: i18n.t('modulos.stimulsoft.bias_chart', idioma),
    traceability_standards: i18n.t(
      'modulos.stimulsoft.traceability_standards',
      idioma
    ),
    calibration_location: i18n.t(
      'modulos.stimulsoft.calibration_location',
      idioma
    ),
    temperature: i18n.t('modulos.stimulsoft.temperature', idioma),
    relative_humidity: i18n.t('modulos.stimulsoft.relative_humidity', idioma),
    information: i18n.t('modulos.stimulsoft.information', idioma),
    ambient_conditions: i18n.t('modulos.stimulsoft.ambient_conditions', idioma),
    digital_authorization: i18n.t(
      'modulos.stimulsoft.digital_authorization',
      idioma
    ),
    authorized_signatory: i18n.t(
      'modulos.stimulsoft.authorized_signatory',
      idioma
    ),
    replaced_certificate: i18n.t(
      'modulos.stimulsoft.replaced_certificate',
      idioma
    ),
    settings: i18n.t('modulos.stimulsoft.settings', idioma),
    input_signal: i18n.t('modulos.stimulsoft.input_signal', idioma),
    smallest_graduation: i18n.t(
      'modulos.stimulsoft.smallest_graduation',
      idioma
    ),
    measurement_range: i18n.t('modulos.stimulsoft.measurement_range', idioma),
    certificate_code: i18n.t('modulos.stimulsoft.certificate_code', idioma),
    next_calibration_in: i18n.t(
      'modulos.stimulsoft.next_calibration_in',
      idioma
    ),
    no_Equipment_type: i18n.t('modulos.stimulsoft.no_Equipment_type', idioma),
    no_certificate: i18n.t('modulos.stimulsoft.no_certificate', idioma),
    of_preposition: i18n.t('modulos.stimulsoft.of_preposition', idioma),
    inProgress: i18n.t('modulos.stimulsoft.inProgress', idioma),
    canceled: i18n.t('modulos.stimulsoft.canceled', idioma),
    pending_signature: i18n.t('modulos.stimulsoft.pending_signature', idioma),
    calibration_point: i18n.t('modulos.stimulsoft.calibration_point', idioma),
    proc_26_obs: i18n.t('modulos.stimulsoft.proc_26_obs', idioma),
    section_7_incerteza: i18n.t(
      'modulos.stimulsoft.section_7_incerteza',
      idioma
    ),
    section_7_erro_medicao: i18n.t(
      'modulos.stimulsoft.section_7_erro_medicao',
      idioma
    ),
    section_7_values_temperature: i18n.t(
      'modulos.stimulsoft.section_7_values_temperature',
      idioma
    ),
    section_7_signature: i18n.t(
      'modulos.stimulsoft.section_7_signature',
      idioma
    ),
    section_7_valid_document: i18n.t(
      'modulos.stimulsoft.section_7_valid_document',
      idioma
    ),
    sensor_diameter: i18n.t('modulos.stimulsoft.sensor_diameter', idioma),
    sensor_length: i18n.t('modulos.stimulsoft.sensor_length', idioma),
    immersion_depht: i18n.t('modulos.stimulsoft.immersion_depht', idioma),
    spectral_range: i18n.t('modulos.stimulsoft.spectral_range', idioma),
    proportion_ds: i18n.t('modulos.stimulsoft.proportion_ds', idioma),
    distance: i18n.t('modulos.stimulsoft.distance', idioma),
    size: i18n.t('modulos.stimulsoft.size', idioma),
    type: i18n.t('modulos.stimulsoft.type', idioma),
    position: i18n.t('modulos.stimulsoft.position', idioma),
    indicacao_item_calibrado: i18n.t("modulos.stimulsoft.indicacao_item_calibrado", idioma),
    calculated_constant: i18n.t(
      'modulos.stimulsoft.calculated_constant',
      idioma
    ),
    sensor_code: i18n.t('modulos.stimulsoft.sensor_code', idioma),
    seccion_diameter: i18n.t('modulos.stimulsoft.seccion_diameter', idioma),
    emissivity: i18n.t('modulos.stimulsoft.emissivity', idioma),
    gravity_acceleration: i18n.t(
      'modulos.stimulsoft.gravity_acceleration',
      idioma
    ),
    air_density: i18n.t('modulos.stimulsoft.air_density', idioma),
    atmospheric_pressure: i18n.t(
      'modulos.stimulsoft.atmospheric_pressure',
      idioma
    ),
    standard_temperature: i18n.t(
      'modulos.stimulsoft.standard_temperature',
      idioma
    ),
    standard_pressure: i18n.t('modulos.stimulsoft.standard_pressure', idioma),
    operation_principle: i18n.t(
      'modulos.stimulsoft.operation_principle',
      idioma
    ),
    standard: i18n.t('modulos.stimulsoft.standard', idioma),
    classe: i18n.t('modulos.stimulsoft.classe', idioma),
    frequence: i18n.t('modulos.stimulsoft.frequence', idioma),
    nominal_value: i18n.t('modulos.stimulsoft.nominal_value', idioma),
    lower_limit: i18n.t('modulos.stimulsoft.lower_limit', idioma),
    upper_limit: i18n.t('modulos.stimulsoft.upper_limit', idioma),
    connection: i18n.t('modulos.stimulsoft.connection', idioma),
    imersion: i18n.t('modulos.stimulsoft.imersion', idioma),
    thermometric_liquid: i18n.t(
      'modulos.stimulsoft.thermometric_liquid',
      idioma
    ),
    estimated_resolution: i18n.t(
      'modulos.stimulsoft.estimated_resolution',
      idioma
    ),
    sensor_temperature: i18n.t('modulos.stimulsoft.sensor_temperature', idioma),
    material: i18n.t('modulos.stimulsoft.material', idioma),
    sample_material: i18n.t('modulos.stimulsoft.sample_material', idioma),
    batch: i18n.t('modulos.stimulsoft.batch', idioma),
    resolution: i18n.t('modulos.stimulsoft.resolution', idioma),
    measuring_position: i18n.t('modulos.stimulsoft.measuring_position', idioma),
    calibration_temperature: i18n.t(
      'modulos.stimulsoft.calibration_temperature',
      idioma
    ),
    simulation_temperature: i18n.t(
      'modulos.stimulsoft.simulation_temperature',
      idioma
    ),
    reference_information: i18n.t(
      'modulos.stimulsoft.reference_information',
      idioma
    ),
    indicador_data: i18n.t('modulos.stimulsoft.indicador_data', idioma),
    electrode_data: i18n.t('modulos.stimulsoft.electrode_data', idioma),
    technical_specification_standard: i18n.t(
      'modulos.stimulsoft.technical_specification_standard',
      idioma
    ),
    reference_sound_pressure_level: i18n.t(
      'modulos.stimulsoft.reference_sound_pressure_level',
      idioma
    ),
    microphone_data: i18n.t('modulos.stimulsoft.microphone_data', idioma),
    preamplifier_data: i18n.t('modulos.stimulsoft.preamplifier_data', idioma),
    limit: i18n.t('modulos.stimulsoft.limit', idioma),
    detour: i18n.t('modulos.stimulsoft.detour', idioma),
    secction_7_additional_information: i18n.t(
      'modulos.stimulsoft.secction_7_additional_information',
      idioma
    ),
    reference_standard_for_calibration: i18n.t(
      'modulos.stimulsoft.reference_standard_for_calibration',
      idioma
    ),
    sinal: i18n.t('modulos.stimulsoft.sinal', idioma),
    parameter: i18n.t('modulos.stimulsoft.parameter', idioma),
    self_generated_noise_microphone_installed: i18n.t(
      'modulos.stimulsoft.self_generated_noise_microphone_installed',
      idioma
    ),
    c_weighted_frequency_with_microphone_installed: i18n.t(
      'modulos.stimulsoft.c_weighted_frequency_with_microphone_installed',
      idioma
    ),
    c_weighted_frequency: i18n.t(
      'modulos.stimulsoft.c_weighted_frequency',
      idioma
    ),
    a_weighted_frequency: i18n.t(
      'modulos.stimulsoft.a_weighted_frequency',
      idioma
    ),
    level_linearity_on_the_reference_level_range: i18n.t(
      'modulos.stimulsoft.level_linearity_on_the_reference_level_range',
      idioma
    ),
    toneburst_response_fast: i18n.t(
      'modulos.stimulsoft.toneburst_response_fast',
      idioma
    ),
    toneburst_response_slow: i18n.t(
      'modulos.stimulsoft.toneburst_response_slow',
      idioma
    ),
    c_weighted_peak_sound_level_8_Hz: i18n.t(
      'modulos.stimulsoft.c_weighted_peak_sound_level_8_Hz',
      idioma
    ),
    c_weighted_peak_sound_level_500_Hz: i18n.t(
      'modulos.stimulsoft.c_weighted_peak_sound_level_500_Hz',
      idioma
    ),
    overload_indication: i18n.t(
      'modulos.stimulsoft.overload_indication',
      idioma
    ),
    self_generated: i18n.t('modulos.stimulsoft.self_generated', idioma),
    frequency_and_time_weightings_at_1_kHz: i18n.t(
      'modulos.stimulsoft.frequency_and_time_weightings_at_1_kHz',
      idioma
    ),

    cell_constant: i18n.t('modulos.stimulsoft.cell_constant', idioma),
    ph_simulation: i18n.t('modulos.stimulsoft.ph_simulation', idioma),
    unit_measurement: i18n.t('modulos.stimulsoft.unit_measurement', idioma),
    obtaining_the_value_of_the_conductivity_cell_constant_kcal: i18n.t(
      'modulos.stimulsoft.obtaining_the_value_of_the_conductivity_cell_constant_kcal',
      idioma
    ),
    obtaining_conductivity_with_mcr: i18n.t(
      'modulos.stimulsoft.obtaining_conductivity_with_mcr',
      idioma
    ),
    mrc_reference_value: i18n.t(
      'modulos.stimulsoft.mrc_reference_value',
      idioma
    ),
    commercial_conductivity_cell_constant_value_kcel: i18n.t(
      'modulos.stimulsoft.commercial_conductivity_cell_constant_value_kcel',
      idioma
    ),
    conductivity_cell_constant_value_obtained_after_kcal_calibration: i18n.t(
      'modulos.stimulsoft.conductivity_cell_constant_value_obtained_after_kcal_calibration',
      idioma
    ),
    section_7_conductivity_cell_constant_kcel_commercial_conductivity_cell_constant_value:
      i18n.t(
        'modulos.stimulsoft.section_7_conductivity_cell_constant_kcel_commercial_conductivity_cell_constant_value',
        idioma
      ),
    section_7_conductivity_cell_constant_kcal_cell_constant_value_obtained_after_calibration_with_mrc:
      i18n.t(
        'modulos.stimulsoft.section_7_conductivity_cell_constant_kcal_cell_constant_value_obtained_after_calibration_with_mrc',
        idioma
      ),
    vertical_resolution: i18n.t(
      'modulos.stimulsoft.vertical_resolution',
      idioma
    ),
    horizontal_resolution: i18n.t(
      'modulos.stimulsoft.horizontal_resolution',
      idioma
    ),
    channel: i18n.t('modulos.stimulsoft.channel', idioma),
    specification: i18n.t('modulos.stimulsoft.specification', idioma),
    value_obtained: i18n.t('modulos.stimulsoft.value_obtained', idioma),
    distance_from_nominal_value: i18n.t(
      'modulos.stimulsoft.distance_from_nominal_value',
      idioma
    ),
    thermal_expansion_coefficient: i18n.t(
      'modulos.stimulsoft.thermal_expansion_coefficient',
      idioma
    ),
    quantity_items: i18n.t('modulos.stimulsoft.quantity_items', idioma),
    nominal_lenght_lc: i18n.t('modulos.stimulsoft.nominal_lenght_lc', idioma),
    length_obtained: i18n.t('modulos.stimulsoft.length_obtained', idioma),
    error_lc: i18n.t('modulos.stimulsoft.error_lc', idioma),
    value_division: i18n.t('modulos.stimulsoft.value_division', idioma),
    item: i18n.t('modulos.stimulsoft.item', idioma),
    circularityChart: i18n.t('modulos.stimulsoft.circularityChart', idioma),
    length_indications: i18n.t('modulos.stimulsoft.length_indications', idioma),
    shape_and_position: i18n.t('modulos.stimulsoft.shape_and_position', idioma),
    evaluated_parameter: i18n.t(
      'modulos.stimulsoft.evaluated_parameter',
      idioma
    ),
    surface_flatness_fixed_side: i18n.t(
      'modulos.stimulsoft.surface_flatness_fixed_side',
      idioma
    ),
    surface_flatness_moving_side: i18n.t(
      'modulos.stimulsoft.surface_flatness_moving_side',
      idioma
    ),
    surface_parallelism: i18n.t(
      'modulos.stimulsoft.surface_parallelism',
      idioma
    ),
    nominal_length: i18n.t('modulos.stimulsoft.nominal_length', idioma),
    length_obtained_central: i18n.t(
      'modulos.stimulsoft.length_obtained_central',
      idioma
    ),
    maximum_minimum_deviations: i18n.t(
      'modulos.stimulsoft.maximum_minimum_deviations',
      idioma
    ),
    perpendicularity_diagram: i18n.t(
      'modulos.stimulsoft.perpendicularity_diagram',
      idioma
    ),
    applicant_and_service_data: i18n.t(
      'modulos.stimulsoft.applicant_and_service_data',
      idioma
    ),
    type_of_square: i18n.t('modulos.stimulsoft.type_of_square', idioma),
    direction_and_side_of_surface: i18n.t(
      'modulos.stimulsoft.direction_and_side_of_surface',
      idioma
    ),
    length_evaluated: i18n.t('modulos.stimulsoft.length_evaluated', idioma),
    item_type: i18n.t('modulos.stimulsoft.item_type', idioma),
    project_code: i18n.t('modulos.stimulsoft.project_code', idioma),
    overall_dimensions: i18n.t('modulos.stimulsoft.overall_dimensions', idioma),
    side: i18n.t('modulos.stimulsoft.side', idioma),
    nominal_diameter: i18n.t('modulos.stimulsoft.nominal_diameter', idioma),
    maximum_variation: i18n.t('modulos.stimulsoft.maximum_variation', idioma),
    average_affective_diameter_of_the_three_wires: i18n.t(
      'modulos.stimulsoft.average_affective_diameter_of_the_three_wires',
      idioma
    ),
    results_of_inquiries: i18n.t(
      'modulos.stimulsoft.results_of_inquiries',
      idioma
    ),
    transducer_serial_number: i18n.t(
      'modulos.stimulsoft.transducer_serial_number',
      idioma
    ),
    indicator_serial_number: i18n.t(
      'modulos.stimulsoft.indicator_serial_number',
      idioma
    ),
    type_of_material: i18n.t('modulos.stimulsoft.type_of_material', idioma),
    applied_traction_force: i18n.t(
      'modulos.stimulsoft.applied_traction_force',
      idioma
    ),
    comparator_measuring_range: i18n.t(
      'modulos.stimulsoft.comparator_measuring_range',
      idioma
    ),
    amplifier_measuring_range: i18n.t(
      'modulos.stimulsoft.amplifier_measuring_range',
      idioma
    ),
    standard_deviation: i18n.t('modulos.stimulsoft.standard_deviation', idioma),
    amplifier_serial_number: i18n.t(
      'modulos.stimulsoft.amplifier_serial_number',
      idioma
    ),
    results_evaluated_parameters: i18n.t(
      'modulos.stimulsoft.results_evaluated_parameters',
      idioma
    ),
    flank_diameter: i18n.t('modulos.stimulsoft.flank_diameter', idioma),
    step: i18n.t('modulos.stimulsoft.step', idioma),
    go: i18n.t('modulos.stimulsoft.go', idioma),
    fillet_angle: i18n.t('modulos.stimulsoft.fillet_angle', idioma),
    diameter_variation: i18n.t('modulos.stimulsoft.diameter_variation', idioma),
    scheme: i18n.t('modulos.stimulsoft.scheme', idioma),
    circularity_error: i18n.t('modulos.stimulsoft.circularity_error', idioma),
    angle_indications: i18n.t('modulos.stimulsoft.angle_indications', idioma),
    doesnt_pass: i18n.t('modulos.stimulsoft.doesnt_pass', idioma),
    repeatability_error: i18n.t(
      'modulos.stimulsoft.repeatability_error',
      idioma
    ),
    hysteresis_error: i18n.t('modulos.stimulsoft.hysteresis_error', idioma),
    feed_direction_error: i18n.t(
      'modulos.stimulsoft.feed_direction_error',
      idioma
    ),
    forward_return_direction_error: i18n.t(
      'modulos.stimulsoft.forward_return_direction_error',
      idioma
    ),
    orientative_diagram: i18n.t(
      'modulos.stimulsoft.orientative_diagram',
      idioma
    ),
    incerteza: i18n.t('modulos.stimulsoft.incerteza', idioma),
    media: i18n.t('modulos.stimulsoft.media', idioma),
    arredondamento: i18n.t('modulos.stimulsoft.arredondamento', idioma),
    valor_menor_dvisao: i18n.t('modulos.stimulsoft.valor_menor_dvisao', idioma),
    erro_histerese: i18n.t('modulos.stimulsoft.erro_histerese', idioma),
    regiao_parametro: i18n.t('modulos.stimulsoft.regiao_parametro', idioma),
    retrological_characteristics_presented_by_the_instrument: i18n.t('modulos.stimulsoft.retrological_characteristics_presented_by_the_instrument', idioma),
    valueSmallestGraduation: i18n.t(
      'modulos.stimulsoft.valueSmallestGraduation',
      idioma
    ),
    valorMenorDivisaoPercent: i18n.t(
      'modulos.stimulsoft.valorMenorDivisaoPercent',
      idioma
    ),
    faixa_medicao_espectral: i18n.t(
      'modulos.stimulsoft.faixa_medicao_espectral',
      idioma
    ),
    largura_banda: i18n.t('modulos.stimulsoft.largura_banda', idioma),
    velocidade_varredura: i18n.t(
      'modulos.stimulsoft.velocidade_varredura',
      idioma
    ),
    comprimento_onda_nm: i18n.t(
      'modulos.stimulsoft.comprimento_onda_nm',
      idioma
    ),
    escala_fotometrica_uv: i18n.t(
      'modulos.stimulsoft.escala_fotometrica_uv',
      idioma
    ),
    escala_fotometrica_vis: i18n.t(
      'modulos.stimulsoft.escala_fotometrica_vis',
      idioma
    ),
    parametros_avaliados: i18n.t(
      'modulos.stimulsoft.parametros_avaliados',
      idioma
    ),
    afastamento_valor_nominal: i18n.t(
      'modulos.stimulsoft.afastamento_valor_nominal',
      idioma
    ),
    imagens_item_medido: i18n.t(
      'modulos.stimulsoft.imagens_item_medido',
      idioma
    ),
    projeto_item_medido: i18n.t(
      'modulos.stimulsoft.projeto_item_medido',
      idioma
    ),
    tabela_resultados_detalhada: i18n.t(
      'modulos.stimulsoft.tabela_resultados_detalhada',
      idioma
    ),
    especificacao: i18n.t('modulos.stimulsoft.especificacao', idioma),
    erro_medicao: i18n.t('modulos.stimulsoft.erro_medicao', idioma),
    valor_divisao: i18n.t('modulos.stimulsoft.valor_divisao', idioma),
    intervalo_medicao: i18n.t('modulos.stimulsoft.intervalo_medicao', idioma),
    erro_adjacente: i18n.t('modulos.stimulsoft.erro_adjacente', idioma),
    erro_repetitividade: i18n.t(
      'modulos.stimulsoft.erro_repetitividade',
      idioma
    ),
    configuracao: i18n.t('modulos.stimulsoft.configuracao', idioma),
    software_indicador: i18n.t('modulos.stimulsoft.software_indicador', idioma),
    versao_software_indicador: i18n.t(
      'modulos.stimulsoft.versao_software_indicador',
      idioma
    ),
    numero_serie_indicador: i18n.t(
      'modulos.stimulsoft.numero_serie_indicador',
      idioma
    ),
    erro_medicao_equipamento: i18n.t(
      'modulos.stimulsoft.erro_medicao_equipamento',
      idioma
    ),
    classe_exatidao: i18n.t('modulos.stimulsoft.classe_exatidao', idioma),
    tipo_balanca: i18n.t('modulos.stimulsoft.tipo_balanca', idioma),
    tipo_auto_ajuste: i18n.t('modulos.stimulsoft.tipo_auto_ajuste', idioma),
    calibracao_excentricidade: i18n.t(
      'modulos.stimulsoft.calibracao_excentricidade',
      idioma
    ),
    imagens_orientativas_excentricidade: i18n.t(
      'modulos.stimulsoft.imagens_orientativas_excentricidade',
      idioma
    ),
    desvio_padrao_informado: i18n.t(
      'modulos.stimulsoft.desvio_padrao_informado',
      idioma
    ),
    atividade_ajuste_reparo: i18n.t(
      'modulos.stimulsoft.atividade_ajuste_reparo',
      idioma
    ),
    calibracao_nao_isenta_controle: i18n.t(
      'modulos.stimulsoft.calibracao_nao_isenta_controle',
      idioma
    ),
    material_amostra: i18n.t('modulos.stimulsoft.material_amostra', idioma),
    volume: i18n.t('modulos.stimulsoft.volume', idioma),
    codigo: i18n.t('modulos.stimulsoft.codigo', idioma),
    histerese: i18n.t('modulos.stimulsoft.histerese', idioma),
    tipo_escala: i18n.t('modulos.stimulsoft.tipo_escala', idioma),
    tipo_nomenclatura: i18n.t('modulos.stimulsoft.tipo_nomenclatura', idioma),
    resolucao_adotada: i18n.t('modulos.stimulsoft.resolucao_adotada', idioma),
    sentidos_horario_antihorario: i18n.t(
      'modulos.stimulsoft.sentidos_horario_antihorario',
      idioma
    ),
    zero_inversao: i18n.t('modulos.stimulsoft.zero_inversao', idioma),
    numero_serie_apalpador: i18n.t(
      'modulos.stimulsoft.numero_serie_apalpador',
      idioma
    ),
    numero_serie_braco: i18n.t('modulos.stimulsoft.numero_serie_braco', idioma),
    ruido_fundo: i18n.t('modulos.stimulsoft.ruido_fundo', idioma),
    diagrama_orientativo_distribuicao: i18n.t(
      'modulos.stimulsoft.diagrama_orientativo_distribuicao',
      idioma
    ),
    tipo_perfil_rugosidade: i18n.t(
      'modulos.stimulsoft.tipo_perfil_rugosidade',
      idioma
    ),
    abertura_nominal: i18n.t('modulos.stimulsoft.abertura_nominal', idioma),
    diametro_fio_nominal: i18n.t(
      'modulos.stimulsoft.diametro_fio_nominal',
      idioma
    ),
    sentido_medicao_horizontal: i18n.t(
      'modulos.stimulsoft.sentido_medicao_horizontal',
      idioma
    ),
    classe_declarada: i18n.t('modulos.stimulsoft.classe_declarada', idioma),
  };
}

export function def_linguagem_dataSource(dataSource, idioma) {
  var sigla = idioma.value ?? idioma;
  const linguagem_1 = def_linguagem(sigla);
  const linguagem_2 = def_linguagem(sigla != 'en-US', 'en-US');

  dataSource.language_1 = linguagem_1;
  dataSource.language_2 = linguagem_2;

  if (sigla == 'en-US') {
    dataSource.language_1 = linguagem_2;
  }
}
